module.exports = __webpack_public_path__ + "i18n/en_0b09edecbd5a958afa6187e74064d24e.json";


//////////////////
// WEBPACK FOOTER
// ./app/assets/i18n/en.json
// module id = aY29
// module chunks = 154